import React from 'react';
import { confirmAlert } from 'react-confirm-alert';
import CustomDialog from '../custom-dialog/CustomDialog';

const confirmDiscardChanges = (redirectUrl, history) => {
  confirmAlert({
    customUI: ({ onClose }) => {
      return (
        <CustomDialog
          title="Are you sure"
          text="Are you sure you want to discard changes?"
          cancelText="Cancel"
          confirmText="Discard"
          onClose={onClose}
          handleConfirming={() => history.push(redirectUrl)}
        />
      );
    }
  });
};

export default confirmDiscardChanges;
